'use client';

import Link from 'next/link';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IBurgerMenu } from '@/types/components/burgerMenu';

export const BurgerMenu: React.FC<IBurgerMenu> = ({
  iconSpots,
  iconEvents,
  iconMap,
  iconDl,
  openModale,
  closeMenu,
}) => {
  return (
    <div className="relative z-50">
      <div className="absolute right-0 w-64 bg-black text-white rounded-lg shadow-lg border border-gray-700 z-10">
        <div className="absolute -top-2 right-5 w-4 h-4 bg-black transform rotate-45 border-t border-l border-gray-700 z-0"></div>

        <div className="flex flex-col">
          <Link
            href="/spots"
            onClick={closeMenu}
            className="flex items-center p-3 hover:bg-zinc-200 border-b border-gray-600 hover:text-red-600 rounded-lg"
          >
            <FontAwesomeIcon icon={iconSpots} className="mr-2" />
            Spots
          </Link>
          <Link
            href="/events"
            onClick={closeMenu}
            className="flex items-center p-3 hover:bg-zinc-200 border-b border-gray-600 hover:text-red-600 rounded-lg"
          >
            <FontAwesomeIcon icon={iconEvents} className="mr-2" />
            Évènements
          </Link>
          {/* <Link
            href="/map"
            onClick={closeMenu}
            className="flex items-center p-3 hover:bg-zinc-200 border-b border-gray-600 hover:text-red-600 rounded-lg"
          >
            <FontAwesomeIcon icon={iconMap} className="mr-2" />
            Carte
          </Link> */}
          <button
            onClick={() => {
              openModale();
              closeMenu();
            }}
            className="flex items-center p-3 hover:bg-zinc-200 hover:text-red-600 rounded-lg"
          >
            <FontAwesomeIcon icon={iconDl} className="mr-2" />
            Télécharger l&apos;app
          </button>
        </div>
      </div>
    </div>
  );
};
